import type { CurrentBreakpoint } from '../useResponsive/useResponsive.types';
import { useCheckMinWidth } from './useCheckMinWidth';
import type { MinWidthAttributes } from './types';

export const useCheckBreakpoint = (): CurrentBreakpoint => {
  const minWidth = useCheckMinWidth();

  return usePrimedCheckBreakpoint(minWidth);
};

export const usePrimedCheckBreakpoint = (
  minWidth: MinWidthAttributes,
): CurrentBreakpoint => {
  return {
    isMobile: !minWidth.tablet,
    isTablet: minWidth.tablet && !minWidth.desktop,
    isDesktop: minWidth.desktop && !minWidth.largeDisplay,
    isLargeDisplay: minWidth.largeDisplay,
  };
};
